import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/about.scss";
import { Link } from "react-router-dom";

function About() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  return (
    <div className="about">
      <Header />

      <main className="about-main">
        <section className="about-hero">
          <div className="about-hero-text">
            <h1 className="about-title">Hey neighbor, we’re Rivergrove.</h1>
            <p className="about-sub">
              Our mission is simple: make neighborhoods safer. As a smart
              security company, we strive to make safety and peace of mind
              accessible to everyone and empower communities to work together
              for one another.
            </p>
          </div>
        </section>

        <section className="about-block about-story">
          <div className="about-media">
            <img src="/main/a2.jpg" alt="" />
          </div>
          <div className="about-copy">
            <div className="eyebrow">Our Story</div>
            <h2 className="about-h2">Innovation from the start.</h2>
            <p>
              We started in a garage in 2012 when our founder asked a simple
              question: what if you could answer the front door from your phone?
              After many late nights and endless tinkering, our first Video
              Doorbell was born.
            </p>
            <p>
              That invention has grown into over a decade of groundbreaking
              products and next-level features. At the core of everything, it’s
              the same drive to bridge the distance between people and what they
              care about.
            </p>
            <p>
              For the raw, unfiltered story of how Rivergrove began in Jamie
              Siminoff’s own words,{" "}
              <Link to="/about" onClick={toTop} className="about-link">
                read the book
              </Link>
              .
            </p>
          </div>
        </section>

        <section className="about-block about-products">
          <div className="about-copy">
            <div className="eyebrow">Our Products</div>
            <h2 className="about-h2">Connection in your hands.</h2>
            <p>
              From that very first Video Doorbell all the way up to the latest
              3D Motion Detection, everything we dream, design and engineer is
              fueled by the desire to bring people closer.
            </p>
            <p>
              We didn’t stop at the front door. Whether it’s sounding a siren
              with a tap or answering the door while you’re away, every device
              and service we create is meant to help you feel connected, secure
              and empowered.
            </p>
            <Link to="/shop" onClick={toTop} className="btn primary">
              Shop Now
            </Link>
          </div>
          <div className="about-media">
            <img src="/main/a3.jpg" alt="" />
          </div>
        </section>

        <section className="about-block about-commit">
          <div className="about-media">
            <img src="/main/a4.jpg" alt="" />
          </div>
          <div className="about-copy">
            <div className="eyebrow">Our Commitment</div>
            <h2 className="about-h2">Keeping communities close.</h2>
            <p>
              We believe engaged communities are stronger communities, and we’re
              committed to connecting people to their neighborhoods through
              programs, the Neighbors App and support for mission-based
              organizations.
            </p>
            <p>
              Learn more about how we’re working with communities and
              neighborhoods across the world.
            </p>
            <Link to="/about" onClick={toTop} className="btn outline">
              Read More
            </Link>
          </div>
        </section>

        <section className="about-blog">
          <div className="eyebrow">Rivergrove Blog</div>
          <h3 className="about-blog-title">Stay in the know.</h3>
          <p className="about-blog-sub">
            From tips on getting the most out of your devices to the latest
            product announcements, the Rivergrove Blog has you covered.
          </p>
          <Link to="/about" onClick={toTop} className="btn outline">
            Read More
          </Link>
        </section>

        <section className="about-contact">
          <div className="contact-right">
            <details className="contact-acc" open>
              <summary>Press and Media</summary>
              <div className="contact-acc-body">
                <a href="mailto:depot@rivergrove.blog" className="contact-link">
                  depot@rivergrove.blog
                </a>
              </div>
            </details>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default About;
